import { Typography, Button } from "components/atoms";
import { Modal } from "../Modal";
import { CloseIcon, Spinner } from "components/atoms/Icon";
import "./index.scss";

interface IProps {
  handleOnClose: () => void;
  isOpen: boolean;
  theme?: "light" | "dark";
  notificationContent?: string;
   isLoading?: boolean;
}

export const NotificationModal = ({
  handleOnClose,
  isOpen,
  theme = "light",
  notificationContent = "Welcome to your Student Dashboard!",
  isLoading = false,
}: IProps) => {
  return (
    <Modal isOpen={isOpen} onClose={handleOnClose} theme={theme} >
      <div className="notification-modal-wrapper">
      <div className="notification-modal-header">
        <div className="notification-modal-header-typography">
          <div className="title-typography-wrapper">
            <Typography
              label="Notification"
              variant="h4Bold"
              styles="notification-modal-header-typography-custom-style"
            />
          </div>
        </div>
        <div
          className="notification-modal-header-close-icon"
          onClick={handleOnClose}
        >
          <CloseIcon theme={theme} />
        </div>
      </div>
        <div className="notification-modal-body">
          <div className="notification-modal-description-section">
            {isLoading ? (
              <div className="loading-spinner">
                <Spinner theme={theme} />
              </div>
            ) : (
              <div
              className={`notification-text ${theme === 'dark' ? 'notification-text-dark' : 'notification-text-light'}`}
              dangerouslySetInnerHTML={{ __html: notificationContent }}
              />
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};